<template>
  <div class="content-base" v-if="HomeService">
    <rl-title :show-name="HomeService.name" />
    <div class="content-body">
        <home-content-item
            v-for="(item,index) in HomeService.childClassify" :key="index"
            :content-info="item" :local-url="urls[index]">
        </home-content-item>
    </div>
  </div>
</template>

<script>
import HomeContentItem from "./Item";
import RlTitle from "@/components/Title";
export default {
  name: "HomeContent",
  components: {RlTitle, HomeContentItem},
  props:{
    HomeService:{
      default(){
        return {}
      }
    }
  },
  data(){
    return{
      urls:[
        require('../../../../assets/Home/menu_video_blu@3x.png'),
        require('../../../../assets/Home/menu_play_blu@3x.png'),
        require('../../../../assets/Home/menu_camera_whi@3x.png'),
      ]
    }
  }
}
</script>

<style lang="less" scoped>
  .content-base{
    width: 74.5vw;
    margin: 0 auto;
    min-height: 650px;
    position: relative;
      .content-body{
        display: flex;
        justify-content: space-between;
      }
  }
</style>